export default {
    $white: '#FFFFFF',
    $app_red: '#DD4D5E',
    $app_darkred: '#C43445',
    $app_blue: '#3A98CF',
    $app_darkblue: '#187EBA'
}